<div class="modal-header">
  <h5 class="modal-title" data-cy="ticket-terminate-modal-title">
    {{ 'TERMINATE_TICKET.TITLE' | translate }}
  </h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="onNoClick()"></button>
</div>
<div class="modal-body">
  @if(isFormReady()) {
    <form [formGroup]="this.terminationForm">
      <div class="mb-3">
        @if (dateInputType === TerminationDateInputType.DATEPICKER_MONTH) {
          <div class="row align-items-center d-flex">
            <div class="col-12 col-md-8">
              <app-custom-input id="terminationDate"
                                [customFormGroup]="this.terminationForm"
                                [label]="PFLICHTFELDMARKER+' '+('TERMINATE_TICKET.TERMINATION_DATE_MONTH' | translate)"
                                [type]="'month'"
                                data-content="dd.MM.yyyy"
                                [placeholder]="'yyyy-MM'"
                                [min]="earliestTerminationDate | date: 'yyyy-MM'"
                                [max]="latestTerminationDate | date: 'yyyy-MM'"
                                [pattern]="'[0-9]{4}-[0-9]{2}'"
                                data-cy="termination-date-month"
                                (onchange)="setFinalTerminationDate()"
              ></app-custom-input>
            </div>
            <div class="col-12 col-md-4">
              <button class="btn btn-outline-primary mt-2" style="height:36px;"
                      (click)="setEarliestTerminationDate()"
                      data-cy="termination-set-earliest-date-button"
              >
                {{ 'TERMINATE_TICKET.BUTTONS.SET_EARLIEST_DATE' | translate }}
              </button>
            </div>
          </div>
          <div class="text-muted ms-1">
            {{ 'TERMINATE_TICKET.TERMINATION_DATE_MONTH_INFO' | translate }}
          </div>
          @if (terminationForm?.get('terminationDate')?.invalid && (terminationForm?.get('terminationDate')?.dirty || terminationForm?.get('terminationDate')?.touched)) {
            <div class="text-danger ms-1">
              {{ 'TERMINATE_TICKET.ERROR_DATE' | translate }}
            </div>
          }
        } @else if (dateInputType === TerminationDateInputType.DATEPICKER_DAY) {
          <div class="row align-items-center d-flex">
            <div class="col-12 col-md-8">
              <app-custom-input id="terminationDate"
                                [customFormGroup]="this.terminationForm"
                                [type]="'date'"
                                [label]="PFLICHTFELDMARKER+' '+('TERMINATE_TICKET.TERMINATION_DATE_DAY' | translate)"
                                data-content="dd.MM.yyyy"
                                [min]="earliestTerminationDate"
                                [max]="latestTerminationDate"
                                data-cy="termination-date-day"
                                (onchange)="setFinalTerminationDate()"
              ></app-custom-input>
            </div>
            <div class="col-12 col-md-4">
              <button class="btn btn-outline-primary mt-3" style="height:36px;"
                      (click)="setEarliestTerminationDate()"
                      data-cy="termination-set-earliest-date-button"
              >
                {{ 'TERMINATE_TICKET.BUTTONS.SET_EARLIEST_DATE' | translate }}
              </button>
            </div>
          </div>
          @if (terminationForm?.get('terminationDate')?.invalid && (terminationForm?.get('terminationDate')?.dirty || terminationForm?.get('terminationDate')?.touched)) {
            <div class="text-danger ms-1">
              {{ 'TERMINATE_TICKET.ERROR_DATE' | translate }}
            </div>
          }
        }
      </div>
    </form>
  }
</div>
<div class="modal-footer">
  @if(finalTerminationDate){
    <div class="text w-100 ms-1">
      {{ 'TERMINATE_TICKET.TERMINATION_DATE_FINAL' | translate:{ Datum: (finalTerminationDate | date:'dd.MM.yyyy') } }}
    </div>
  }
  <div class="d-flex w-100 justify-content-end ms-1">
    <button type="button" class="btn btn-secondary" data-cy="termination-modal-cancel-btn" (click)="onNoClick()">{{ 'TERMINATE_TICKET.BUTTONS.CANCEL' | translate }}</button>
    <button type="button" class="btn btn-primary" data-cy="termination-modal-submit-btn"  (click)="onSubmit()">{{ 'TERMINATE_TICKET.BUTTONS.OK' | translate }}</button>
  </div>
</div>
